import { CentraJS } from "@frend-digital/centra-js-client";
import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";
import { ofetch } from "ofetch";

export type AddToCartOptions<FormattedSelection> = {
  variables: { itemId: string; comment?: string };
  customerToken: string;
  apiUrl: string;
  formatter: (selection: BaseSelectionResponse) => FormattedSelection;
};

const addToCart = async <FormattedSelection>({
  variables,
  customerToken,
  apiUrl: api,
  formatter,
}: AddToCartOptions<FormattedSelection>) => {
  CentraJS.suspend();

  const res = await ofetch(`${api}/items/${variables.itemId}`, {
    headers: {
      "API-token": customerToken || "",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: variables.comment ? { comment: variables.comment } : undefined,
  });

  CentraJS.resume();

  return formatter(res);
};

export default addToCart;
